import type { ReactNode } from "react";
import estilos from "./ListaDatos.module.css";

/** Pares rótulo–valor. Los datos vacíos no se muestran. */
export function ListaDatos({ datos }: { readonly datos: readonly (readonly [string, ReactNode])[] }) {
  const conValor = datos.filter(([, v]) => v !== null && v !== undefined && v !== "" && v !== false);
  return (
    <dl className={estilos.datos}>
      {conValor.map(([rotulo, valor]) => (
        <div key={rotulo} className={estilos.fila}>
          <dt>{rotulo}</dt>
          <dd>{valor}</dd>
        </div>
      ))}
    </dl>
  );
}
